const componentName = 'payment';
const serviceName = 'PatientPaymentRealtimeComponent';
const moduleName = 'doxy.realtime.components.patient-payment';

export { componentName, serviceName, moduleName };

import paymentPopup from './patient/payment-popup/payment-popup';
import PatientPaymentRealtimeComponent from './patient/payment.ts';

export default angular
  .module(moduleName, [paymentPopup])
  .service(serviceName, PatientPaymentRealtimeComponent).name;
